module.exports = __webpack_public_path__ + "static/media/ev7.ecf82871.jpg";